export default __webpack_public_path__ + "static/media/gmail.49c66076.svg";